module.exports = __webpack_public_path__ + "img/grayXIcon.21b0b8d5.svg";